import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function setCCOrderOpenState({ isOpen }: { isOpen: boolean }): RootActionTypes {
  return {
    type: ActionTypes.SET_CC_ORDER_OPEN_STATE,
    payload: isOpen,
  };
}
